import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesByProductQuery } from "../graphql/queries";
import type {
  AnalyticsSalesByProductQueryType,
  AnalyticsSalesByProductQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesByProductQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesByProductQueryType,
    AnalyticsSalesByProductQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesByProductQueryType,
    AnalyticsSalesByProductQueryVariablesType
  >(AnalyticsSalesByProductQuery, options);
};
